<ng-container *ngrxLet="tiles$ as tiles">
    @if (tiles.length) {
        <app-tile-list [tiles]="tiles" (tileClick)="onTileClicked($event)" />
    } @else {
        <div class="activity-grid--no-activities">
            <priva-notification>{{ 'ERROR.TITLE.NO_ACTIVITIES_FOUND' | translate }}</priva-notification>
        </div>
    }
</ng-container>
